<template>
  <input 
    type="text" 
    class="text" 
    :class="options.css_classes" 
    :id="'field-' + options.id" 
    :name="'fields[' + options.id + ']'" 
    :placeholder="options.placeholder_text" 
    v-model="fieldValue" />
</template>

<script>
export default { 
  name: 'EmailField',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/
      if (regex.test(this.value)) {
        return true
      }
      return false
    }
  },
  computed: {
    fieldValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val
        })
      }
    }
  }
}
</script>
